import React from 'react';
import { FaGlasses, FaMicroscope, FaCamera, FaPalette, FaMoneyBillWave, FaBox } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaGlasses />,
  2: <FaMicroscope />,
  3: <FaCamera />,
  4: <FaPalette />,
  5: <FaMoneyBillWave />,
  6: <FaBox />
};

const OpticalIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="optical"
      gradient="#4facfe 0%, #00f2fe 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default OpticalIndustryPage;

